import React from "react";
import NavbarHeader from "./Navbar";
import FooterBfsg from "./FooterBfsg";
const Policy = () => {
  return (
    <div>
      <section className="Policy">
        <NavbarHeader />
        <div className="container">
          <h1 className="text-start">
            Privacy Policy
            <hr></hr>
          </h1>
          <p>
            BSFG ("we", "us", or "our") is a curated collection of the best
            niche beauty brands and independent retailers, dedicated to
            providing exceptional service and building personalized
            relationships with our customers. This Privacy Policy explains how
            we collect, use, disclose, and protect your personal information
            when you use our website, mobile application, and social media
            pages.
          </p>
          <h2>Our Commitment to Your Privacy</h2>
          <p>
            We understand the importance of protecting your privacy and are
            committed to respecting the privacy rights of all our users. We have
            implemented measures to ensure the security of your personal
            information and only collect information that is necessary to
            provide our services and improve your experience.
          </p>
          <h2>Information We Collect</h2>
          <p>
            We collect several types of information from and about you,
            including:
          </p>

          <p>
            <b>Personal Information:</b> This includes information that can be
            used to identify you, such as your name, email address, phone
            number, mailing address, billing address, payment information, and
            beauty preferences (e.g., skin type, hair type).
          </p>

          <p>
            <b>Usage Data:</b> This includes information about your activity on
            the Services, such as the pages you visit, the products you
            purchase, the services you use, and the search terms you use.
          </p>

          <p>
            <b>Engagement Data:</b> This includes information about your
            interactions with our communications, such as whether you open our
            emails, click on links in our emails, or follow us on social media.
          </p>
          <h2>How We Collect Information</h2>
          <p>
            We collect information from you in a variety of ways, including:
          </p>
          <p>
            When you create an account or make a purchase: We collect personal
            information, such as your name, email address, and billing address,
            when you create an account or make a purchase on the Services.
          </p>
          <p>
            When you use the Services: We collect usage data and engagement data
            through cookies and other tracking technologies.
          </p>
          <p>
            <b>From third-party sources:</b> We may collect information about
            you from third-party sources, such as social media platforms,
            marketing partners, and public databases, to personalize your
            experience and offer relevant recommendations.
          </p>
          <h2>How We Use Information</h2>
          <p>
            We use the information we collect for a variety of purposes,
            including:
          </p>
          <ul>
            <li>To provide and improve the Services</li>
            <li>To process your orders and transactions</li>
            <li>
              To send you personalized communications, such as product
              recommendations, offers, and updates about our services
            </li>
            <li>To personalize your experience on the Services</li>
            <li>To analyze how the Services are used</li>
            <li>To comply with legal and regulatory obligations</li>
          </ul>
          <p></p>
          <h2>Sharing of Information</h2>
          <p>
            We may share your information with third-party service providers who
            help us operate the Services, such as payment processors, shipping
            companies, marketing partners, and data analytics providers. We will
            only share your information with these providers to the extent
            necessary to provide you with the Services.
          </p>
          <p>
            We will not share your personal information with any third party for
            their own marketing purposes without your consent.
          </p>
          <h2>Your Choices</h2>
          <p>
            You have choices about how we collect, use, and share your
            information. You can:
          </p>
          <ul>
            <li>
              {" "}
              Opt out of receiving marketing and promotional communications from
              us
            </li>
            <li>Update your personal information</li>
            <li>Delete your account</li>
          </ul>

          <h2>Data Security</h2>
          <p>
            We take reasonable steps to protect your information from
            unauthorized access, disclosure, alteration, or destruction.
            However, no internet transmission or electronic storage is ever
            completely secure, and we cannot guarantee the security of your
            information.
          </p>
          <h2>Children's Privacy</h2>
          <p>
            The Services are not directed to children under the age of 13. We do
            not knowingly collect personal information from children under the
            age of 13. If you are a parent or guardian and you believe that your
            child has provided us with personal information, please contact us.
          </p>
          <h2>International Transfers</h2>
          <p>
            Your information may be transferred to, stored, and processed in
            countries other than your own, where data protection laws may be
            different from those in your country. By using the Services, you
            consent to the transfer of your information to these countries.
          </p>
          <h2>Changes to this Policy</h2>
          <p>
            We may update this Policy from time to time. We will notify you of
            any changes by posting the new Policy on the Services.
          </p>
          <h2>Contact Us</h2>
          <p>If you have any questions about this Policy, please contact us:</p>
          <p>
            <b>By email: </b>
            <a href="mailto:customerservice@beautyfashionsales.com">
              customerservice@beautyfashionsales.com
            </a>
          </p>

          <p></p>
          <p>
            This Privacy Policy reflects our commitment to providing exceptional
            service and building trust with our customers. We are always open to
            your feedback and suggestions. Please feel free to contact us if you
            have any questions.
          </p>
          <hr></hr>
        </div>
        <FooterBfsg />
      </section>
    </div>
  );
};

export default Policy;
